<template>
  <!-- Questions and answers, shared by the home page and /faq. Which questions people open tells us
       what worries them, so opening one is tracked (FAQ_OPEN, with the page area). -->
  <v-expansion-panels class="as-faq-list" @change="onChange">
    <v-expansion-panel v-for="item in items" :key="item.key" class="mb-4">
      <v-expansion-panel-header>
        <div class="as-faq-list__question">
          <v-icon color="var(--color-pallet-1)" class="mr-3 flex-shrink-0" size="20">{{ item.icon }}</v-icon>
          <h3 class="as-faq-list__question-text">{{ $t(`pages.home-view.faq.questions.${item.key}.question`) }}</h3>
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <p class="as-faq-list__answer">{{ $t(`pages.home-view.faq.questions.${item.key}.answer`, { days: freeTrialDays }) }}</p>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { FREE_TRIAL_DAYS } from '@/domains/website/websiteLinks'
import { trackWebsiteEvent, WebsiteEvent } from '@/domains/website/websiteTracking'

export default {
  name: 'FaqList',
  props: {
    /** Entries of FAQ_ITEMS (faqCatalogue.js). */
    items: { type: Array, required: true },
    /** WebsiteLocation of the page area, reported with each opened question. */
    location: { type: String, required: true }
  },
  data: () => ({
    freeTrialDays: FREE_TRIAL_DAYS
  }),
  methods: {
    /** @param {number|undefined} index the opened panel; undefined when one is closed */
    onChange (index) {
      if (index === undefined || index === null) return
      trackWebsiteEvent(this.$gtag, WebsiteEvent.FAQ_OPEN, { question: this.items[index].key, location: this.location })
    }
  }
}
</script>

<style>
.as-faq-list__question {
  display: flex;
  align-items: center;
  text-align: left;
  min-width: 0;
}

.as-faq-list__question-text {
  font-size: 1.1rem;
  font-weight: 700;
  line-height: 1.4;
  color: var(--color-pallet-1);
  margin: 0;
  overflow-wrap: anywhere;
}

.as-faq-list__answer {
  text-align: left;
  color: var(--color-pallet-2);
  line-height: 1.6;
  margin: 0;
}
</style>
